export default __webpack_public_path__ + "static/media/gallery_00.69c29d8f.jpg";